export const ERROR_SCREEN = {
    NO_INTERNET: {
        HEADER_TEXT: "No internet connection!",
        DETAILED_TEXT: "Please check your connection and try again.",
    },
    UNEXPECTED_ERROR: {
        HEADER_TEXT: "Something went wrong!",
        DETAILED_TEXT: "Some unexpected error occurred, please try again later.",
    },
    PAGE_NOT_FOUND: {
        HEADER_TEXT: "Oops! Page not found!",
        DETAILED_TEXT: "The page you were looking for doesn't exist.",
    },
    NO_RESULT_FOUND: {
        HEADER_TEXT: "No results found!",
        DETAILED_TEXT: "The app you are looking for doesn’t exist.",
    },
    INVALID_TOKEN: {
        HEADER_TEXT: "Account Already in Use",
        DETAILED_TEXT:
            "Another user is logged in with the same credentials. Please sign in again to continue.",
    },
};
